import { useNotifications } from "@tosize/ui";

export function useGenericError() {
	const { notify } = useNotifications();

	function onError(error: unknown) {
		if (error instanceof Error) {
			notify({ variant: "danger", title: error.message });
		}

		if (typeof error === "string") {
			notify({ variant: "danger", title: error });
		}

		console.error(error);
	}

	return onError;
}
